const ADMIN_CATEGORIES_PATH = "/admin/categories/:categories(.*?)";

module.exports = {
	path: "/admin",
	component: require("@views/Admin").default,
	meta: {
		showButton: true,
		title: "Admin",
		icon: ["far", "key"],
		primary: true
	},
	children: [
		{
			path: "/admin",
			component: require("@views/admin/Home").default,
			meta: {
				title: "Team Settings"
				// icon: ['far', 'users'],
			}
		},
		{
			path: "/admin/users",
			component: require("@views/admin/Users").default,
			meta: {
				title: "Users",
				// icon: ['far', 'users'],
				search: {
					placeholder: "Search Users",
					show: true
				}
			},
			children: [
				{
					path: "/admin/users/create",
					component: require("@views/admin/users/Create").default,
					props: true,
					children: [
						{
							path: "/admin/users/create",
							component: require("@views/admin/users/Form")
								.default
						}
					]
				},
				{
					path: "/admin/users/import",
					component: require("@views/admin/users/Import").default,
					props: true
				},
				{
					path: "/admin/users/:id",
					component: require("@views/admin/users/User").default,
					props: true,
					children: [
						{
							path: "/admin/users/:id",
							component: require("@views/admin/users/Details")
								.default,
							props: true
						},
						{
							path: "/admin/users/:id/edit",
							component: require("@views/admin/users/Form")
								.default
						}
					]
				}
			]
		},
		{
			path: "/admin/roles",
			component: require("@views/admin/Roles").default,
			meta: {
				title: "Roles"
			},
			children: [
				{
					path: "/admin/roles/:slug",
					component: require("@views/admin/Role").default,
					props: true
				}
			]
		},
		{
			path: "/admin/products",
			component: require("@views/admin/Products").default,
			meta: {
				title: "Products"
			},
			children: [
				{
					path: "/admin/products/import",
					component: require("@views/admin/products/Import").default,
					props: true
				},
				{
					path: "/admin/products/:id",
					component: require("@views/admin/products/Part").default,
					props: true
				}
			]
		},
		{
			path: "/admin/attributes",
			component: require("@views/admin/Attributes").default,
			meta: {
				showButton: true,
				title: "Attributes",
				search: {
					placeholder: "Search Attributes",
					show: true
				}
			},
			children: [
				// {
				// 	path: '/admin/attributes/create',
				// 	component: require('@views/admin/attributes/Create').default,
				// 	props: true,
				// 	children: [
				// 		{
				// 			path: '/admin/attributes/create',
				// 			component: require('@views/admin/attributes/Form').default,
				// 		}
				// 	]
				// },
				{
					path: "/admin/attributes/import",
					component: require("@views/admin/attributes/Import")
						.default,
					props: true
				},
				{
					path: "/admin/attributes/:id",
					component: require("@views/admin/attributes/Attribute")
						.default,
					props: true,
					children: [
						{
							path: "/admin/attributes/:id",
							component: require("@views/admin/attributes/Details")
								.default,
							props: true
						},
						{
							path: "/admin/attributes/:id/edit",
							component: require("@views/admin/attributes/Form")
								.default
						}
					]
				}
			]
		},
		{
			path: "/admin/customers",
			component: require("@views/admin/Customers").default,
			meta: {
				title: "Customers"
			},
			children: [
				{
					path: "/admin/customers/import",
					component: require("@views/admin/customers/Import").default,
					props: true
				},
				{
					path: "/admin/customers/:id",
					component: require("@views/admin/customers/Customer")
						.default,
					props: true
				}
			]
		},
		{
			path: "/admin/alerts",
			component: require("@views/admin/Alerts").default,
			meta: {
				title: "Alerts",
				search: {
					placeholder: "Search Recipients",
					show: true
				}
				// icon: ['far', 'users'],
			}
		},
		{
			path: "/admin/documents",
			component: require("@views/admin/Documents").default,
			meta: {
				title: "Documents"
				// icon: ['far', 'users'],
			},
			children: [
				{
					path: "/admin/documents/upload",
					component: require("@views/admin/documents/Upload").default,
					props: true
				},
				{
					path: "/admin/documents/:id",
					component: require("@views/admin/documents/Document")
						.default,
					props: true,
					children: [
						{
							path: "/admin/documents/:id",
							component: require("@views/admin/documents/Details")
								.default,
							props: true
						},
						{
							path: "/admin/documents/:id/edit",
							component: require("@views/admin/documents/Form")
								.default
						}
					]
				}
			]
		},
		{
			path: `${ADMIN_CATEGORIES_PATH}?`,
			component: require("@views/admin/Categories").default,
			meta: {
				title: "Document Center"
				// icon: ['far', 'users'],
			},
			props: route => ({
				slug: parseCategorySlug(route)
			}),
			children: [
				{
					path: ADMIN_CATEGORIES_PATH,
					component: require("@views/admin/document-center/Category")
						.default,
					props: route => ({
						slug: parseCategorySlug(route)
					}),
					children: [
						{
							path: `${ADMIN_CATEGORIES_PATH}/document/upload`,
							component: require("@views/admin/document-center/DocumentUpload")
								.default,
							props: true
						},
						{
							path: `${ADMIN_CATEGORIES_PATH}/document/:id/edit`,
							component: require("@views/admin/document-center/DocumentForm")
								.default,
							props: true
						},
						{
							path: `${ADMIN_CATEGORIES_PATH}/document/:id`,
							component: require("@views/admin/document-center/DocumentDetails")
								.default,
							props: true
						},
						{
							path: `${ADMIN_CATEGORIES_PATH}/edit`,
							component: require("@views/admin/document-center/CategoryForm")
								.default,
							props: true
						},
						{
							path: ADMIN_CATEGORIES_PATH,
							component: require("@views/admin/document-center/CategoryDetails")
								.default,
							props: true
						}
					]
				}
			]
		}
	]
};

function parseCategorySlug(route) {
	let { categories = [] } = route.params;

	if (typeof categories === "string") {
		return categories
			.replace(/(\/document\/(\d+|upload))?(\/edit)?\/?$/, "")
			.split("/")
			.filter(s => s)
			.join("_");
	}
}
